import { useContext, useEffect, useState } from "react";
import axios from "axios";
import { AppContext } from "../AppContext";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";

const SignalDashboard = () => {
    const [tenantId, setTenantId] = useState('');
    const { role, user, fetchUserData } = useContext(AppContext);
    const navigate = useNavigate();

    const signalDashboard = useQuery("Dashboard", () =>
        axios.get(
            process.env.REACT_APP_PLANNER_API_END_POINT +
            "/garden/dashboard/" +
            process.env.REACT_APP_MURATPASA_DASHBOARD
        ), { refetchOnWindowFocus: false });

    useEffect(() => {
        try {
            fetchUserData();
            const userSettings = localStorage.getItem("settings");
            const parsed = JSON.parse(userSettings);
            const parsedTenantId = parsed.hostname?.split('.')[0];
            setTenantId(parsedTenantId);
        } catch (error) {
            console.error(error);
        }
    }, []);

    useEffect(() => {
        if ((user !== null && user.id !== 156) || (tenantId !== "" && tenantId !== "muratpasa")) {
            navigate('/control-center/gardens');
        }
    }, [user, tenantId])

    return (
        <div className="maincontainer bg-white bg-opacity-20 rounded-2xl ml-4 mr-4 text-white flex flex-col gap-4 ">
            {(user !== null && user.id === 156 && tenantId !== null && tenantId === "muratpasa") && (
                <div className="rounded-lg overflow-hidden h-screen">
                    {signalDashboard.data && <iframe
                        title="Dashboard"
                        src={signalDashboard.data.data.url}
                        frameborder="0"
                        width="100%"
                        height="90%"
                        allowtransparency
                    ></iframe>}
                </div>
            )}
        </div>
    )
};

export default SignalDashboard;